var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Cookies from 'js-cookie';
import * as amplitude from '@amplitude/analytics-browser';
import { ampli } from '@bitcoin-portal/web-ampli';
import { LOCALES } from './languages';
const AMPLITUDE_API_KEY = `498ce6d5e47c1f87c8c0d2bd1078c4d1`;
export const getUrl = (locale, defaultLocale) => {
    if (window && window.location) {
        const { origin, pathname } = window.location;
        const languages = Object.keys(LOCALES);
        const splitPath = pathname.split('/');
        if (!languages.includes(locale))
            return '';
        // language is not default locale (usually 'en') and is an available language
        if (locale !== defaultLocale && !languages.includes(splitPath[1])) {
            return `${origin}/${locale}${pathname}`;
        }
        // language is available
        if (languages.includes(splitPath[1])) {
            // language is defaultLocale (usually 'en')
            if (locale === defaultLocale) {
                splitPath.splice(1, 1);
                return `${origin}${splitPath.join('/')}`;
            }
            splitPath[1] = locale;
            return `${origin}${splitPath.join('/')}`;
        }
    }
    return '';
};
export const setWindowLocation = (dest) => {
    if (!window)
        return;
    if (window.NetlifyCmsApp)
        return;
    if (window.location)
        window.location.href = dest;
};
export const setPreferredLocale = (locale, cookieName, cookieDomain) => {
    Cookies.set(cookieName, locale, process.env.NODE_ENV === 'development'
        ? {}
        : {
            domain: cookieDomain,
            secure: true,
            expires: 365,
        });
    window.localStorage.setItem('bitcoincom-locale', locale);
};
export const setMoonpayCookie = () => {
    Cookies.set('hideMoonpay', 'true', process.env.NODE_ENV === 'development'
        ? {}
        : {
            domain: 'bitcoin.com',
            secure: true,
            expires: 365,
        });
};
export const getMoonpayCookie = () => {
    return Cookies.get('hideMoonpay') || 'false';
};
export const getPreferredLocale = (cookieName) => {
    if (!cookieName)
        return undefined;
    if (!window)
        return undefined;
    const localLocale = window.localStorage.getItem(cookieName) || undefined;
    const locale = Cookies.get(cookieName) || localLocale;
    return locale;
};
export const getMoonpayStatus = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const moonpayUrl = 'https://api.moonpay.com/v3/ip_address/?apiKey=pk_live_k6WSd0AaHVEXPV4WlBBrsvRMrAhRH';
        const Axios = yield import('axios');
        const { data: { isAllowed }, } = yield Axios.get(moonpayUrl);
        return isAllowed;
    }
    catch (error) {
        return undefined;
    }
});
export const getLanguageHeader = () => {
    let lang = 'en';
    const req = new XMLHttpRequest();
    req.open('GET', window.location.href, false);
    req.send(null);
    const headers = req.getAllResponseHeaders().toLowerCase().split('\n');
    const language = headers.find((val) => {
        return val.startsWith('accept-language');
    });
    const splitLangauge = language === null || language === void 0 ? void 0 : language.split(':')[1];
    if (splitLangauge)
        lang = splitLangauge;
    return lang;
};
export const trackEvent = (category, action, label) => {
    if (window && window.dataLayer) {
        window.dataLayer.push({
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            event: 'eventBus',
        });
    }
};
export const initAmplitude = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = urlParams.get('sessionId');
        const deviceId = urlParams.get('deviceId');
        const config = {};
        if (sessionId) {
            config.sessionId = Number(sessionId);
        }
        if (deviceId) {
            config.deviceId = deviceId;
        }
        yield amplitude.init(AMPLITUDE_API_KEY, undefined, config)
            .promise;
        ampli.load({
            client: {
                apiKey: AMPLITUDE_API_KEY,
            },
        });
    }
    catch (e) {
        console.error('Error initialising Amplitude', e);
    }
});
export const sendAmpEvent = (label, properties) => {
    try {
        amplitude.track(label, properties);
    }
    catch (error) {
        console.log('Error sending Amplitude event', error);
    }
};
//# sourceMappingURL=helpers.js.map